import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { StatusLembreteEnum } from '../../../../shared/enum/status-lembrete.enum';
import { Lembrete } from '../../../../shared/model/lembrete/lembrete.model';
import { SituacaoLembrete } from '../models/situacao-lembrete.model';

@Component({
  selector: 'app-card-lembrete-contato',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './card-lembrete-contato.component.html',
  styleUrl: './card-lembrete-contato.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardLembreteContatoComponent {
  readonly lembrete = input.required<Lembrete>();

  readonly template = computed(() => {
    const template = this.lembrete().template;
    return template?.id ? `${template.id} - ${template.nome ?? ''}` : '';
  });

  readonly situacao = computed<SituacaoLembrete>(() => {
    const lembrete = this.lembrete();
    if (lembrete.status === StatusLembreteEnum.CONCLUIDO) return { texto: 'Concluído', classe: 'concluido' };
    if (lembrete.status === StatusLembreteEnum.ERRO) return { texto: 'Erro', classe: 'erro' };
    if (lembrete.status === StatusLembreteEnum.RODANDO) return { texto: 'Processando', classe: 'pendente' };
    const dia = new Date(lembrete.dataHora);
    const hoje = new Date();
    const amanha = new Date();
    amanha.setDate(hoje.getDate() + 1);
    if (dia.getTime() < hoje.getTime()) return { texto: 'Atrasado', classe: 'atrasado' };
    if (dia.toDateString() === hoje.toDateString()) return { texto: 'Hoje', classe: 'pendente' };
    if (dia.toDateString() === amanha.toDateString()) return { texto: 'Amanhã', classe: 'pendente' };
    return { texto: dia.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }), classe: 'pendente' };
  });
}
